import { FindIFtttListByTrigger, Create, BatchCreate } from '@/axios/IFttt.js';
import { GetAutoTemplateById } from '@/axios/IDevice.js';
import { fetchTriggerAbility, getTriggerList } from '@/utils/triggerAbility';

export async function getElfDefaultIfttt(device, payload, curTriggerList) {
  const triggerList = curTriggerList || getTriggerList(await fetchTriggerAbility(device.VDeviceId));
  let commercialdefaultRecommendation = [];

  triggerList.forEach(trigger => {
    if (Array.isArray(trigger.UI?.commercialdefaultRecommendation)) {
      commercialdefaultRecommendation = commercialdefaultRecommendation.concat(
        trigger.UI?.commercialdefaultRecommendation
      );
    }
  });

  const templateIDs = commercialdefaultRecommendation.map(item => item.templateID);

  const templatesRes = await GetAutoTemplateById({
    id: templateIDs.join(',')
  });

  return getSaveTemplatePackageConfig(device, payload, triggerList, templatesRes.Result || []);
}

function getSaveTemplatePackageConfig(device, payload, triggerList, templates) {
  debugger
  const ParentGpnos = (device.ParentGpnos || '').replace(/@/g, '').split(',');
  const Gpno = payload.batchedGpNo || payload.gpNo || ParentGpnos[ParentGpnos.length - 1];
  const iftttCommonInfo = {
    Gpno: Gpno,
    TRI_Relation: 0,
    IsManual: false,
    IsEnable: true,
    TriggerType: 0,
    TimePeriod: {
      effectivedate: "2019-01-01,2088-12-31",
      holiday: false,
      time: "00:00",
      weeks: "Mon Tues Wed Thur Fri Sat Sun",
      zone: 0,
    },
    ShowEntry: 1
  };

  const triggerCommonInfo = {
    VDeviceId: device.VDeviceId,
    DeviceName: device.DeviceName,
    AreaName: device.AreaName,
    IsDel: false,
    ClassSku: device.ClassSku,
  };

  let iftttInfo = [];
  let recomends = [];

  triggerList.forEach((trigger, index) => {
    let ExecuteTaskList = {};
    let needAdd = true;
    console.log('trigger 1', trigger);

    const commercialdefaultRecommendation = trigger.UI?.commercialdefaultRecommendation || [];
    const defaultRecommendationIds = commercialdefaultRecommendation.map(
      recommendation => recommendation.templateID
    );
      console.log('trigger 2', commercialdefaultRecommendation);
    commercialdefaultRecommendation.forEach(recommend => {
      const curTemplates = templates.filter(template => 
        template.Id === recommend.templateID
        // defaultRecommendationIds.includes(template.Id)
      );
      const curAreaList = curTemplates.reduce((pre, next) => {
        return pre.concat(next.AreaActionList || []);
      }, []);
      const curDeviceList = curTemplates.reduce((pre, next) => {
        return pre.concat(next.DeviceActionList || []);
      }, []);
      console.log('trigger 3', recommend, templates, curTemplates, curAreaList);
      let ExecuteTaskList = null;

      // AREA
      if (payload.ActionType === 6) {
        ExecuteTaskList = {
          ActionType: 6,
          Gpno: payload.gpNo,
          AreaName: payload.areaName || device.AreaName,
          Values: curAreaList.map((action) => ({
            ControlType: action.Content.ControlType,
            Value: action.Content.Value
          }))
        };
      }

      // DEVICE
      if (payload.ActionType === 0) {
        const batchedDevice = payload.device;
        ExecuteTaskList = {
          ActionType: 0,
          AreaName: batchedDevice.AreaName,
          ChannelId: batchedDevice.ChildId,
          DeviceName: batchedDevice.DeviceName,
          // ClassSku: batchedDevice.ClassSku,
          VDeviceId: batchedDevice.VDeviceId,
          // GpNo: batchedDevice.Gpno,
          ActionList: curDeviceList.map((action) => action.Content)
        };
      }

      let ifttt = {
        ...iftttCommonInfo,
        TriggerList: [{
          ...triggerCommonInfo,
          TriggerList: [{
            ExtraKeyId: trigger.ExtraKeyId,
            KeyId: trigger.KeyID,
            MsgId: trigger.MsgID,
            OperationType: Number(recommend.OperationValue),
            Value1: Number.isInteger(Number(recommend.Value1)) ? recommend.Value1 : Number(recommend.DefaultValue),
            Value2: Number.isInteger(Number(recommend.Value2)) ? recommend.Value2 : null,
          }]
        }],
        ExecuteTaskList: [ExecuteTaskList],
        UITemplateId: recommend.templateID,
        UITemplateVersion: recommend.version,
        IFtttName: recommend.name,
      };

      recomends.push(ifttt);
    });
  });

  console.log('recomends recomends recomends', recomends);
  
  return recomends;
}